import React from 'react';
import './cta.css';

const CTA = () => (
  <div className="gpt3__cta">
    <div className="gpt3__cta-content">
      <h3>Download today on GooglePlay.</h3>
    </div>
    <div className="gpt3__cta-btn">
      <a href = "https://play.google.com/store/apps/details?id=com.codeapp.codely"><button type="button">Download</button></a>
    </div>
  </div>
);

export default CTA;